export default "__VITE_ASSET__odDnZuhT__"